export class AppVersion {
  name: string;
  description: string;
  blocks: AppVersionBlock[];
}

export class AppVersionBlock {
  text: string;
  image: string;
  video: string;
  title: string;
}
